
import React from "react";
import ToolsSection from "./ToolsSection";
import PaintSection from "./PaintSection";
import FloorSection from "./FloorSection";
import PlasticSection from "./PlasticSection";
import { useSelector } from "react-redux";

function InputDesign() {

 /*
   const colorBlocks = [
    { color: "#426884"},
    { color: "#EAD1C6"},
    { color: "#FACDF1"},
    { color: "#94AFC5", },
    { color: "#866D6D", },
    { color: "#D9D9D9", },
  ];
 const FloorBlocks = [
    { name:'Floor1', src: "img/floor1.png"},
    { name:'Floor2', src: "img/floor2.png"},
    { name:'Floor3', src: "img/floor3.png"},
    { name:'Floor4', src: "img/floor4.png"},
   
  ];*/
  const homeproducts = useSelector((state) => state.cart.homeproducts);

  const colorBlocks = homeproducts.length > 0 ? homeproducts.filter((v)=> Number(v.category) === 13 ) : [] ;

  const FloorBlocks =homeproducts.length > 0 ? homeproducts.filter((v)=> Number(v.category) === 14 ) : [] ;

  const lang = useSelector((state) => state.cart.lang);
  return (
    <main className="flex flex-col justify-center ">
      <div className="flex flex-col justify-center items-center w-full ">
        <ToolsSection lang={lang} />
        <PaintSection lang={lang} colorBlocks={colorBlocks} text={true} />
        <FloorSection lang={lang} FloorBlocks={FloorBlocks} text={true} />
        <PlasticSection lang={lang} />
      </div>
    </main>
  );
}

export default InputDesign;
